import deepmerge from 'deepmerge';
import BaseConfig from 'base/config';
import BrandConfig from '@/svenskdam/config';

export default deepmerge(BaseConfig, BrandConfig);